(() => {
  let activeCard = null;
  let selectedDesign = null;

  const getModal = () => document.getElementById('gift-modal');

  const closeModal = () => {
    const modal = getModal();
    if (!modal) return;

    modal.hidden = true;
    document.body.style.overflow = '';
  };

  const resetGiftSelection = () => {
    activeCard = null;
    selectedDesign = null;

    document.querySelectorAll('[data-gift-card]').forEach((card) => {
      card.classList.remove('is-selected');

      delete card.dataset.selectedDesignId;
      delete card.dataset.selectedDesignName;
      delete card.dataset.selectedDesignSrc;
      delete card.dataset.giftMessage;

      const icon = card.querySelector('[data-button-icon]');

      if (icon) {
        icon.textContent = '+';
      }

      const cardImage = card.querySelector(
        '.gift-option-card__image'
      );

      if (cardImage?.dataset.originalSrc) {
        cardImage.src = cardImage.dataset.originalSrc;
        cardImage.srcset = '';
      }
    });

    const modal = getModal();
    const message = modal?.querySelector('#gift-message');

    if (message) {
      message.value = '';
    }
  };

  const openModal = (card) => {
    const modal = getModal();
    if (!modal || !card) return;

    const gallery = modal.querySelector('[data-gift-gallery]');
    const message = modal.querySelector('#gift-message');
    const confirmButton = modal.querySelector('[data-gift-confirm]');
    const template = card.querySelector('[data-design-template]');

    activeCard = card;
    selectedDesign = null;

    const savedDesignId = card.dataset.selectedDesignId || '';
    const savedMessage = card.dataset.giftMessage || '';

    if (gallery) {
      gallery.innerHTML = '';
    }

    if (message) {
      message.value = savedMessage;
    }

    if (confirmButton) {
      confirmButton.disabled = true;
    }

    if (template && gallery) {
      const sourceButtons = [
        ...template.content.querySelectorAll('[data-design-option]')
      ];

      sourceButtons.forEach((sourceButton, index) => {
        const sourceImage = sourceButton.querySelector('img');
        if (!sourceImage) return;

        const image = sourceImage.cloneNode(true);

        image.classList.remove('gift-design__image');
        image.classList.add('gift-modal__design-image');

        image.dataset.designId = sourceButton.dataset.designId || '';
        image.dataset.designName =
          sourceButton.dataset.designName || `Kortdesign ${index + 1}`;

        image.setAttribute('tabindex', '0');
        image.setAttribute('role', 'button');
        image.setAttribute('aria-pressed', 'false');

        const selectImage = () => {
          gallery
            .querySelectorAll('.gift-modal__design-image')
            .forEach((item) => {
              item.classList.remove('active');
              item.setAttribute('aria-pressed', 'false');
            });

          image.classList.add('active');
          image.setAttribute('aria-pressed', 'true');

          selectedDesign = {
            id: image.dataset.designId,
            name: image.dataset.designName,
            src: image.currentSrc || image.src
          };

          if (confirmButton) {
            confirmButton.disabled = false;
          }
        };

        image.addEventListener('click', selectImage);

        image.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            selectImage();
          }
        });

        gallery.appendChild(image);
        if (!savedDesignId && index === 0) {
          selectImage();
        }

        if (
          savedDesignId &&
          image.dataset.designId === savedDesignId
        ) {
          selectImage();

          requestAnimationFrame(() => {
            image.scrollIntoView({
              behavior: 'instant',
              block: 'nearest',
              inline: 'center'
            });
          });
        }
      });
    }

    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  };

  document.addEventListener('click', (event) => {
    const closeButton = event.target.closest('[data-gift-close]');

    if (closeButton) {
      closeModal();
      return;
    }

    const confirmButton = event.target.closest('[data-gift-confirm]');

    if (confirmButton) {
      if (!activeCard || !selectedDesign) return;

      const modal = getModal();
      const message =
        modal?.querySelector('#gift-message')?.value.trim() || '';

        const icon = activeCard.querySelector('[data-button-icon]');

        document.querySelectorAll('[data-gift-card]').forEach((card) => {
        card.classList.remove('is-selected');

        const cardIcon = card.querySelector('[data-button-icon]');

        if (cardIcon) {
            cardIcon.textContent = '+';
        }

        const cardImage = card.querySelector('.gift-option-card__image');

        if (cardImage && cardImage.dataset.originalSrc) {
            cardImage.src = cardImage.dataset.originalSrc;
            cardImage.srcset = '';
        }
        });

        activeCard.classList.add('is-selected');

        activeCard.dataset.selectedDesignId = selectedDesign.id || '';
        activeCard.dataset.selectedDesignName = selectedDesign.name || '';
        activeCard.dataset.selectedDesignSrc = selectedDesign.src || '';
        activeCard.dataset.giftMessage = message;

        if (icon) {
        icon.textContent = '✓';
        }

        const coverImage = activeCard.querySelector('.gift-option-card__image');

        if (coverImage && selectedDesign?.src) {
        if (!coverImage.dataset.originalSrc) {
            coverImage.dataset.originalSrc = coverImage.src;
        }

        coverImage.src = selectedDesign.src;
        coverImage.srcset = '';
        }
      closeModal();
      return;
    }

    const card = event.target.closest('[data-gift-card]');

    if (card) {
      openModal(card);
    }
  });

  document.addEventListener(
    'gift-card:added-to-cart',
    resetGiftSelection
  );

  document.addEventListener('keydown', (event) => {
    const card = event.target.closest?.('[data-gift-card]');

    if (card && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      openModal(card);
      return;
    }

    if (event.key === 'Escape') {
      closeModal();
    }
  });
})();